let btnLoadMore = document.getElementById('load-more');
let articles = document.getElementById('articles');

if (btnLoadMore) {
    btnLoadMore.addEventListener('click', () => {

        let data = new FormData();

        data.append( 'action', 'loadmore' );
        data.append( 'query', load_more_params.posts );
        data.append( 'page', load_more_params.current_page );

        btnLoadMore.classList.add('button--loading');

        fetch(load_more_params.ajaxurl, {
                method: 'POST',
                body: data,
            })
            .then(function (response) {

                response.text().then(function (result) {

                    if( result ) {
                        articles.insertAdjacentHTML('beforebegin',result); // insert new posts
                        btnLoadMore.classList.remove('button--loading');
                        load_more_params.current_page++;

                        console.log(load_more_params);
                        console.log(load_more_params.current_page, load_more_params.max_page);

                        // if last page, remove the button
                        if ( load_more_params.current_page.toString() === load_more_params.max_page.toString() ) {
                            btnLoadMore.remove();
                        }
                    }
                    else {
                        btnLoadMore.remove();
                    }

                })

                btnLoadMore.classList.remove('button--loading');
            })
            .catch(function (error) {
                console.error(error);
            });

    })
}
